@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;

.recentWrapper {
    position: relative;
}

.dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    padding: 8px;
    width: 416px;
    max-height: 220px;
    background-color: v.$palette-white;
    border-radius: 8px;
    overflow-y: auto;
    box-shadow: v.$shadow2;
    transition: v.$transition;
    opacity: 0;
    pointer-events: none;
    @include m.scrollbar();
    z-index: 2;

    &.open {
        opacity: 1;
        pointer-events: all;
    }

    @include m.media(v.$container-tablet) {
        left: 50%;
        right: 0;
        width: 296px;
        transform: translateX(-65%);
        z-index: 8;
        top: 36px;
    }
}

.title {
    margin: 0;
    padding: 8px;
    @include t.text(10px, 12px, 700);
    text-transform: uppercase;
}

.list {
    margin: 0;
}

.item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    border-radius: 8px;
    transition: v.$transition;
    cursor: pointer;

    @media (pointer: fine) {
        &:hover {
            color: v.$palette-orange-2;
            background-color: v.$palette-orange-4;

            svg path {
                fill: v.$palette-orange-2;
            }

            .date {
                color: v.$palette-orange-2;
            }
        }
    }

    .itemButton {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin: 0;
        padding: 8px;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: inherit;
        font: inherit;
        text-align: left;
        cursor: pointer;
    }

    .icon {
        min-width: 12px;
    }

    .content {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .cargoes {
        @include t.text(12px, 20px, 500);
        white-space: nowrap;
    }

    .date {
        @include t.text(12px, 20px, 500);
        color: v.$palette-dirty-70;
        white-space: nowrap;
    }
}

.empty {
    padding: 8px;
    @include t.text(12px, 20px, 500);
    text-align: center;
    color: v.$palette-dirty-70;
}

.footer {
    display: flex;
    justify-content: flex-end;
    padding: 4px 0 0;
    border-top: 1px solid v.$palette-dirty-20;
    margin-top: 4px;
}

.clearBtn {
    @include t.text(12px, 20px, 500);
    color: v.$palette-dirty-100;
}
